import { Skin } from '@wix/add-panel-common';
import { createContext } from 'react';
import type { Context } from './SkinContext.types';

export const SkinContext = createContext<Context>({ skin: Skin.Classic, isClassicFacelift: false });
